import Splide from "@splidejs/splide";
import { AlpineComponent } from "alpinejs";

type SplideComponent = AlpineComponent<object>;

export default (root: HTMLElement): SplideComponent => {
	new Splide(root, {
		type: "loop",
		gap: "1rem",
	}).mount();

	return {};
};
